import { Link } from "react-router-dom";
import SafeImage from "./SafeImage";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A1A1A] text-[#F9F9F7] mt-24"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-20 grid gap-12 md:grid-cols-3">
        <div className="md:col-span-2">
          {/* Same composition as the header — icon SVG + wordmark text in
              `font-display` — so the two brand marks render with identical
              typography across the site. */}
          <div
            data-testid="footer-brand"
            className="flex items-center gap-3"
          >
            <SafeImage
              src="/Pepura-icon-header.avif"
              alt="Pepura Labs logo"
              loading="lazy"
              className="h-9 w-auto"
            />
            <span className="font-display text-3xl font-[700] tracking-tight text-white">
              Pepura Labs
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm text-[#bfcde3] leading-relaxed">
            High quality research-grade Retatrutide. Independently tested by Canadian laboratories.
          </p>
          <p className="overline mt-8 text-[#bfcde3]/70">
            Research use only · Not for human consumption
          </p>
        </div>

        <div>
          <p className="overline text-[#bfcde3]/70 mb-4">Company</p>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/about" className="hover:text-white/80">
                About
              </Link>
            </li>
            <li>
              <Link
                to="/lab-results"
                data-testid="footer-tests-link"
                className="hover:text-white/80"
              >
                Lab results
              </Link>
            </li>
            <li>
              <Link to="/faq" className="hover:text-white/80">
                FAQ & Shipping
              </Link>
            </li>
            <li>
              <Link
                to="/orders"
                data-testid="footer-orders-link"
                className="hover:text-white/80"
              >
                Track order
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                data-testid="footer-contact-link"
                className="hover:text-white/80"
              >
                Contact Us
              </Link>
            </li>
            <li>
              <Link
                to="/privacy"
                data-testid="footer-privacy-link"
                className="hover:text-white/80"
              >
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link
                to="/terms"
                data-testid="footer-terms-link"
                className="hover:text-white/80"
              >
                Terms of Use
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-6 flex items-center justify-center md:justify-start gap-2">
          <p className="text-xs text-[#bfcde3]/60">
            © {new Date().getFullYear()} Pepura Laboratories. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
